import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import VersionChecker from './components/controllers/VersionChecker.js';
import App from './App';
import { UserProvider } from './context/UserProvider';
import { GlobalStatusProvider } from './context/GlobalStatusProvider';
import { CancelProvider } from './context/CancelProvider';
import { AllUserListProvider } from './context/AllUserListProvider';
import { AllAdAccountProvider } from './context/AllAdAccountProvider.js';
import { ReportStatusProvider } from './context/ReportStatusProvider';
import { baseUrl } from './api/api';
import './index.css';


ReactDOM.render(
  <>
    {/* <VersionChecker /> */}
    <CancelProvider>
      <GlobalStatusProvider>
        <UserProvider>
          <AllUserListProvider>
            <AllAdAccountProvider>
              <ReportStatusProvider>
                <Router basename={baseUrl.folderName}>
                  <App />
                </Router>
              </ReportStatusProvider>
            </AllAdAccountProvider>
          </AllUserListProvider>
        </UserProvider>
      </GlobalStatusProvider>
    </CancelProvider>,
  </>,
  document.getElementById('root')
);
